import { styled } from 'baseui'

export const SidebarCard = styled('div', {
  width: '100%',
  boxSizing: 'border-box',
  padding: '1rem',
  marginBottom: '1rem',
  backgroundColor: 'white',
  borderRadius: '0.5rem',
})
